import angular from 'angular';

export class lotosCardsComponent {
  filterText = '';
  listData = [];

  /*@ngInject*/
  constructor($http, $state, $stateParams, OrderNnw, insuranceOffer, Document, $scope, LeftNav, $q, pageSettings, LotosCards) {
    let vm = this;
    vm.cloakView = true;
    vm.pageSettings = pageSettings;
    vm.LeftNav = LeftNav;
    vm.LotosCards = LotosCards;
    vm.query = {
      page: 1,
      limit: 100,
      query: null,
    };

    // LISTENERS
    const loadingBarDisabler = $scope.$on('cfpLoadingBar:completed', function() {
      vm.cloakView = false;
      loadingBarDisabler();
    });

    vm.success = data => {
      vm.listData = data.data;
      vm.deferred.resolve();
    };

    vm.getLotosCardsList = function() {
      vm.deferred = $q.defer();
      vm.promise = vm.deferred.promise;
      vm.LotosCards.getList(this.query)
        .then(vm.success);
    };

    vm.getCsvFile = () => {
      let criteria = angular.copy(vm.query);
      criteria.page = 1;
      criteria.limit = null;

      LotosCards.getCsv(criteria)
        .then(function(data) {
          console.log(data);
          let blob = new Blob([data.data], {type: 'text/plain'});

          if(window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(blob, 'dane.csv');
          } else {
            let e = document.createEvent('MouseEvents'),
              a = document.createElement('a');

            a.download = 'dane.csv';
            a.href = window.URL.createObjectURL(blob);
            a.dataset.downloadurl = ['text/json', a.download, a.href].join(':');
            e.initEvent('click', true, false, window,
              0, 0, 0, 0, 0, false, false, false, false, 0, null);
            a.dispatchEvent(e);
          }
        });
    };
  }

  $onInit() {
    this.LeftNav.setActive('clients', 'main.students');
    this.pageSettings.setTitle('Karty Lotos');
    this.pageSettings.setState('main.lotosCards');
    this.pageSettings.setTheme('lotosCards');
    this.getLotosCardsList();
  }
}

export default angular.module('ngOskCrmApp.main.lotosCards', [])
  .component('lotosCards', {
    template: require('./lotos-cards.pug'),
    controller: lotosCardsComponent,
    controllerAs: 'vm'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/main/lotos-cards/lotos-cards.component.js